export const routes = (parentName) => {
  return [
    {
      path: "audiobook",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Audiobook-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Audiobook-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Audiobook-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Audiobook-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
